import Meetings from '@/pages/private/Meetings/Meetings';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/_dashboard/meetings/')({
  component: Meetings,
});
